/* Botones con la opción "Abre el formulario contra entrega": se ven igual que el botón de EasySell
   y al hacer clic abren su formulario. Las copias NO llevan las clases de EasySell (si las llevan,
   EasySell las procesa otra vez y descuadra los precios). Si EasySell no carga, el enlace sigue funcionando. */
(function () {
  var ROOT_PROPS = ['display', 'flexDirection', 'alignItems', 'justifyContent', 'padding', 'minHeight', 'textAlign',
    'lineHeight', 'textTransform', 'letterSpacing', 'fontFamily', 'gap', 'boxSizing'];
  var TEXT_PROPS = ['display', 'fontSize', 'fontWeight', 'lineHeight', 'textTransform', 'letterSpacing', 'margin', 'fontFamily'];
  function original() { return document.getElementById('es-popup-button'); }
  function copyStyles(from, to, props) {
    var cs = getComputedStyle(from);
    props.forEach(function (p) { to.style[p] = cs[p]; });
  }
  function build(es) {
    var c = es.cloneNode(true);
    c.removeAttribute('id');
    c.className = 'lpa-es-clone';
    copyStyles(es, c, ROOT_PROPS);
    var srcTexts = es.querySelectorAll('span, div');
    var dstTexts = c.querySelectorAll('span, div');
    for (var i = 0; i < dstTexts.length; i++) {
      if (srcTexts[i]) copyStyles(srcTexts[i], dstTexts[i], TEXT_PROPS);
      dstTexts[i].className = '';
    }
    return c;
  }
  function hideOwnSticky() {
    if (document.getElementById('es-sticky')) {
      document.querySelectorAll('.lpa-sticky').forEach(function (s) { s.style.setProperty('display', 'none', 'important'); });
    }
  }
  function swap() {
    hideOwnSticky();
    var es = original();
    if (!es || !es.offsetWidth && !es.querySelector('span')) return;
    document.querySelectorAll('a.lpa-btn[data-lpa-action="easysell"]:not([data-lpa-done])').forEach(function (a) {
      a.setAttribute('data-lpa-done', '1');
      var c = build(es);
      c.setAttribute('role', 'button');
      c.setAttribute('tabindex', '0');
      c.style.setProperty('max-width', '520px');
      c.style.setProperty('width', '100%');
      c.style.setProperty('cursor', 'pointer');
      if (a.closest('.lpa-center, .lpa-guar, .lpa-btnrow--center')) {
        c.style.setProperty('margin-left', 'auto');
        c.style.setProperty('margin-right', 'auto');
      }
      if (a.closest('.lpa-sticky')) {
        c.style.setProperty('font-size', '16px', 'important');
        c.style.setProperty('max-width', '230px');
        c.style.setProperty('padding', '8px 14px', 'important');
        var t = c.querySelectorAll('span, div');
        if (t[0]) t[0].style.fontSize = '15px';
        if (t[1]) t[1].style.fontSize = '11px';
      }
      var open = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var o = original();
        if (o) o.click(); else window.location.hash = 'lpa-hero';
      };
      c.addEventListener('click', open);
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') open(e); });
      a.style.display = 'none';
      a.insertAdjacentElement('afterend', c);
    });
  }
  function start() {
    swap();
    var mo = new MutationObserver(function () { swap(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
